<ng-container *ngrxLet="vm$ as vm">
  @if (showProviderChooser()) {
    <ninety-choose-calendar-provider-dialog
      [integrations]="providerChooserIntegrations()"
      (closed)="onProviderChooserClosed()" />
  } @else if (showCalendarPicker()) {
    <ninety-select-calendar-event-dialog
      [connectionId]="activeCalendarConnectionId()!"
      [calendarService]="calendarEventsService()"
      [selectedEventId]="pickedEvent()?.id"
      [daysAhead]="10"
      rangeLabel="the next 10 days"
      subtitle="Choose from your upcoming meetings"
      (closed)="onCalendarClosed($event)" />
  } @else {
    <h1 mat-dialog-title>Schedule a {{ vm.language.meeting.item }}</h1>
    <h2 mat-dialog-subtitle>Select an agenda, date and presenter for your {{ vm.language.meeting.item }}</h2>

    <mat-dialog-content>
      <form [formGroup]="form" class="parent" data-cy="schedule-meeting-modal">
        <ninety-meeting-bot-calendar-section
          dataCyPrefix="schedule-meeting-dialog"
          [addMeetingAgentControl]="addMeetingAgentControl"
          [pickedEvent]="pickedEvent()"
          (openPicker)="openEventPicker()"
          (openProviderChooser)="onOpenProviderChooser($event)" />
        <div class="agenda">
          <terra-form-field>
            <terra-form-label>Agenda</terra-form-label>
            <terra-select
              formControlName="agenda"
              placeholder="Select Agenda"
              maxHeight="450"
              data-cy="schedule-meeting-dialog_agenda">
              @for (agenda of vm.agendas; track agenda) {
                <terra-option
                  [value]="agenda"
                  attr.data-cy="schedule-meeting-dialog_agenda-option-{{ agenda.displayText }}">
                  {{ agenda.displayText }}
                </terra-option>
              }
            </terra-select>
          </terra-form-field>
        </div>
        <div class="date">
          <terra-form-field>
            <terra-form-label>Date</terra-form-label>
            <terra-date-input
              class="date__field"
              [min]="minDate"
              aria-label="date picker"
              formControlName="date"
              data-cy="schedule-meeting-dialog_date"
              (dateChange)="dateChanged($event)" />
          </terra-form-field>
        </div>
        <div class="time">
          <terra-form-field>
            <terra-form-label>Time</terra-form-label>
            <terra-select formControlName="time" maxHeight="300" data-cy="schedule-meeting-dialog_time">
              @for (option of timeOptions(); track option.value) {
                <terra-option
                  [value]="option.value"
                  attr.data-cy="schedule-meeting-dialog_time-option-{{ option.value }}">
                  {{ option.label }}
                </terra-option>
              }
            </terra-select>
          </terra-form-field>
        </div>
        <div class="cadence">
          <terra-form-field>
            <terra-form-label>Repeating {{ vm.language.meeting.item }} Cadence</terra-form-label>
            <terra-select formControlName="cadence" data-cy="schedule-meeting-dialog_cadence">
              @for (option of cadence$ | async; track option) {
                <terra-option
                  attr.data-cy="schedule-meeting-dialog_cadence-option-{{ option.value }}"
                  class="cadence-option"
                  [value]="option.value">
                  {{ option.name }}
                </terra-option>
              }
            </terra-select>
          </terra-form-field>
        </div>
        <div class="facilitator">
          <terra-form-field>
            <terra-form-label>Facilitator</terra-form-label>
            <terra-select
              formControlName="presenterId"
              maxHeight="300"
              placeholder="Select facilitator"
              data-cy="schedule-meeting-dialog_presenter">
              @for (user of vm.users; track user) {
                <terra-option [value]="user.value">{{ user.name }}</terra-option>
              }
            </terra-select>
          </terra-form-field>
        </div>
        <div class="scribe">
          <terra-form-field>
            <terra-form-label>Scribe</terra-form-label>
            <terra-select
              formControlName="scribeId"
              maxHeight="300"
              placeholder="Select scribe"
              data-cy="schedule-meeting-dialog_scribe">
              <terra-option [value]="undefined">None</terra-option>
              @for (user of vm.users; track user) {
                <terra-option [value]="user.value">{{ user.name }}</terra-option>
              }
            </terra-select>
          </terra-form-field>
        </div>
      </form>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <ninety-button secondary stroked mat-dialog-close class="right-space-10">Cancel</ninety-button>
      <ninety-button
        filled
        primary
        (click)="save()"
        [disabled]="!form.valid || teamUnavailable()"
        data-cy="schedule-meeting-dialog_save">
        Schedule
      </ninety-button>
    </mat-dialog-actions>
  }
</ng-container>
